import produce from 'immer';
import { AnyAction } from 'redux';
import { AUTH_ACTIONS } from '../actions/auth';
import { LEM_ACTIONS } from '../actions/portfolioManager';
import { DropDownOption } from '../types';
import { PortfolioManagerState, ManagedProperty } from '../types/state';
import { ALL } from '../constants';
const initialState: PortfolioManagerState = {
  managedProperties: [],
  lemData: undefined,
  lemLoading: false,
  msLoading: false,
  selectedProperty: undefined,
  msData: undefined,
  selectedBed: undefined,
  bedOptions: [],
  userExpectedRenewals: undefined,
};

const getBedOptions = (
  managedProperties: ManagedProperty[],
  selectedProperty?: string
): DropDownOption[] => {
  if (managedProperties.length < 1) return [];

  const property = selectedProperty ?? managedProperties[0].PropertyCode;

  const BedRooms = managedProperties.find(
    (x) => x.PropertyCode === property
  )?.BedRooms;

  const options: DropDownOption[] = [
    {
      text: 'ALL',
      value: 'ALL',
    },
  ];
  return options.concat(
    BedRooms
      ? BedRooms?.map((x) => {
          const opt: DropDownOption = {
            text: x + '',
            value: x + '',
          };
          return opt;
        })
      : []
  );
};

const lemReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case LEM_ACTIONS.MS_LOADING: {
      return { ...state, msLoading: action.payload };
    }
    case LEM_ACTIONS.LEM_LOADING: {
      return { ...state, lemLoading: action.payload };
    }
    case LEM_ACTIONS.LEM_SELECTED_PROPERTY: {
      let bedOptions = getBedOptions(state.managedProperties, action.payload);

      return Object.assign({}, state, {
        selectedProperty: action.payload,
        bedOptions,
        selectedBed: bedOptions.length > 0 ? bedOptions[0].value : undefined,
      });
    }
    case LEM_ACTIONS.LEM_DATA: {
      return Object.assign({}, state, { lemData: action.payload });
    }
    case LEM_ACTIONS.MS_DATA: {
      return Object.assign({}, state, { msData: action.payload });
    }
    case LEM_ACTIONS.LEM_SELECTED_BED: {
      return Object.assign({}, state, { selectedBed: action.payload });
    }
    case LEM_ACTIONS.LEM_GET_MANAGED_PROPERTIES: {
      return Object.assign({}, state, { managedProperties: action.payload });
    }
    case AUTH_ACTIONS.LOGOUT: {
      return initialState;
    }
    case LEM_ACTIONS.LEM_GET_USER_EXPECTED_RENEWALS: {
      return produce(state, (df) => {
        df.userExpectedRenewals = action.payload;
      });
    }
    case LEM_ACTIONS.LEM_UPDATE_USER_EXPECTED_RENEWALS: {
      return produce(state, (df) => {
        const { Property_Code, Month, Bedroom, Renewal } = action.payload;
        //debugger;
        if (!df.lemData.targetRenewals)
          df.lemData.targetRenewals = [
            {
              Property_Code,
              Month,
              Bedroom: Bedroom === ALL ? '-1' : Bedroom,
              Renewal,
            },
          ];
        else {
          //debugger;
          const renewal = df.lemData.targetRenewals.find((item: any) => {
            return (
              item.Property_Code === Property_Code &&
              item.Month === Month &&
              item.Bedroom === (Bedroom === ALL ? '-1' : Bedroom)
            );
          });
          if (renewal) {
            renewal.Renewal = Renewal;
          } else {
            df.lemData.targetRenewals.push({
              Property_Code,
              Month,
              Bedroom: Bedroom === ALL ? '-1' : Bedroom,
              Renewal,
            });
          }
        }
      });
    }

    default:
      return state;
  }
};

export default lemReducer;
